<template>
  <div>
    <v-container
      :class="{
        'px-5': $vuetify.breakpoint.lgAndUp,
      }"
    >
      <v-snackbar v-model="showCopy" :timeout="6000" color="green" :top="true"
        >{{ $t('Link Copied') }}!</v-snackbar
      >
      <div class="row pt-3">
        <div class="col s12 m8 l6">
          <v-card elevation="2" style="border-radius: 10px; padding: 18px">
            <div class="row mb-2">
              <div class="col s12">
                <v-premium-plan-popup
                  :showAll="false"
                  marginTop="65"
                  v-if="$store.getters.getPackage != 'premium'"
                  style="border-radius: 10px"
                ></v-premium-plan-popup>

                <div class="form-control mb-4">
                  <v-layout>
                    <v-flex xs2 sm1>
                      <div
                        style="
                          background: #0c2f53;
                          width: 30px;
                          height: 30px;
                          border-radius: 50%;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                      >
                        <Typography h5 regular color="color-lightYellow" label="1" />
                      </div>
                    </v-flex>
                    <v-flex xs10 sm11>
                      <Typography
                        style="padding-top: 3px; padding-bottom: 3px"
                        h5
                        semiBold
                        label="Webhook Url"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout class="mb-2">
                    <v-flex xs0 sm1></v-flex>
                    <v-flex xs12 sm11>
                      <div class="row" style="margin-bottom: 0">
                        <div class="col s12 m12">
                          <div
                            class="pa-2 color-darkBlue"
                            style="
                              border: 1px solid;
                              border-radius: 6px;
                              display: flex;
                              flex-direction: row;
                              background: #eeeeee;
                              justify-content: space-between;
                            "
                          >
                            <Typography h7 regular :label="`${webhookUrl}`" />
                            <a
                              href="javascript:void(0);"
                              v-clipboard:copy="webhookUrl"
                              v-clipboard:success="onCopy"
                              v-clipboard:error="onError"
                              style="height: 20px; width: 20px"
                            >
                              <img
                                src="/static/img/Copy.png"
                                alt
                                class="pointer"
                                style="height: 20px; width: 20px"
                              />
                              <transition
                                enter-active-class="animated fadeInUp"
                                leave-active-class="animated fadeOut"
                              ></transition>
                            </a>
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>

                <div class="form-setting mb-4">
                  <v-layout align-center>
                    <v-flex xs2 sm1>
                      <div
                        style="
                          background: #0c2f53;
                          width: 30px;
                          height: 30px;
                          border-radius: 50%;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                      >
                        <Typography h5 regular color="color-lightYellow" label="2" />
                      </div>
                    </v-flex>
                    <v-flex xs9 sm10>
                      <Typography
                        style="padding-top: 3px; padding-bottom: 3px"
                        h5
                        semiBold
                        label="Access Token"
                      />
                    </v-flex>
                    <v-flex xs1 sm1 class="text-xs-right">
                      <div
                        v-if="!isEditAccessToken && $store.getters.getPackage == 'premium'"
                        @click="isEditAccessToken = true"
                      >
                        <img
                          src="/static/img/TooltipEdit.png"
                          alt
                          class="responsive-img pointer"
                          style="height: 20px"
                        />
                      </div>
                      <div
                        v-if="isEditAccessToken && $store.getters.getPackage == 'premium'"
                        @click="saveEditLine('AccessToken')"
                      >
                        <img
                          src="/static/img/editConfirm.png"
                          alt
                          class="responsive-img pointer"
                          style="height: 20px"
                        />
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs0 sm1></v-flex>
                    <v-flex xs12 sm11>
                      <div class="row" style="margin-bottom: 0">
                        <div class="col s12 m12">
                          <div v-if="isEditAccessToken">
                            <textarea
                              maxlength="600"
                              v-model="line.line_access_token"
                              style="resize: vertical; min-height: 70px"
                              :placeholder="'Access Token'"
                              autofocus
                            ></textarea>
                          </div>
                          <div v-else>
                            <Typography
                              h7
                              regular
                              style="word-break: break-all"
                              :label="line.line_access_token ? line.line_access_token : '-'"
                            />
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>

                <div class="form-setting mb-4">
                  <v-layout align-center>
                    <v-flex xs2 sm1>
                      <div
                        style="
                          background: #0c2f53;
                          width: 30px;
                          height: 30px;
                          border-radius: 50%;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                      >
                        <Typography h5 regular color="color-lightYellow" label="3" />
                      </div>
                    </v-flex>
                    <v-flex xs9 sm10>
                      <Typography
                        style="padding-top: 3px; padding-bottom: 3px"
                        h5
                        semiBold
                        label="Channel Secret"
                      />
                    </v-flex>
                    <v-flex xs1 sm1 class="text-xs-right">
                      <div
                        v-if="!isEditChannelSecret && $store.getters.getPackage == 'premium'"
                        @click="isEditChannelSecret = true"
                      >
                        <img
                          src="/static/img/TooltipEdit.png"
                          alt
                          class="responsive-img pointer"
                          style="height: 20px"
                        />
                      </div>
                      <div
                        v-if="isEditChannelSecret && $store.getters.getPackage == 'premium'"
                        @click="saveEditLine('ChannelSecret')"
                      >
                        <img
                          src="/static/img/editConfirm.png"
                          alt
                          class="responsive-img pointer"
                          style="height: 20px"
                        />
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs0 sm1></v-flex>
                    <v-flex xs12 sm11>
                      <div class="row" style="margin-bottom: 0">
                        <div class="col s12 m12">
                          <div v-if="isEditChannelSecret">
                            <textarea
                              autofocus
                              maxlength="600"
                              v-model="line.line_channel_secret"
                              style="resize: vertical; min-height: 70px"
                              :placeholder="'Channel Secret'"
                            ></textarea>
                          </div>
                          <div v-else>
                            <Typography
                              h7
                              regular
                              style="word-break: break-all"
                              :label="line.line_channel_secret ? line.line_channel_secret : '-'"
                            />
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>

                <div class="form-setting mb-4">
                  <v-layout align-center>
                    <v-flex xs2 sm1>
                      <div
                        style="
                          background: #0c2f53;
                          width: 30px;
                          height: 30px;
                          border-radius: 50%;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        "
                      >
                        <Typography h5 regular color="color-lightYellow" label="4" />
                      </div>
                    </v-flex>
                    <v-flex xs9 sm10>
                      <Typography
                        style="padding-top: 3px; padding-bottom: 3px"
                        h5
                        semiBold
                        label="Channel ID"
                      />
                    </v-flex>
                    <v-flex xs1 sm1 class="text-xs-right">
                      <div
                        v-if="!isEditChannelId && $store.getters.getPackage == 'premium'"
                        @click="isEditChannelId = true"
                      >
                        <img
                          src="/static/img/TooltipEdit.png"
                          alt
                          class="responsive-img pointer"
                          style="height: 20px"
                        />
                      </div>
                      <div
                        v-if="isEditChannelId && $store.getters.getPackage == 'premium'"
                        @click="saveEditLine('ChannelId')"
                      >
                        <img
                          src="/static/img/editConfirm.png"
                          alt
                          class="responsive-img pointer"
                          style="height: 20px"
                        />
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs0 sm1></v-flex>
                    <v-flex xs12 sm11>
                      <div class="row" style="margin-bottom: 0">
                        <div class="col s12 m12">
                          <div v-if="isEditChannelId">
                            <textarea
                              autofocus
                              maxlength="600"
                              v-model="line.line_channel_id"
                              style="resize: vertical; min-height: 70px"
                              :placeholder="'Channel ID'"
                            ></textarea>
                          </div>
                          <div v-else>
                            <Typography
                              h7
                              regular
                              style="word-break: break-all"
                              :label="line.line_channel_id ? line.line_channel_id : '-'"
                            />
                          </div>
                        </div>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-container>
  </div>
</template>


<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import Typography from '@/components/elements/Typography.vue'
import moment from 'moment'
import config from '@/config'

export default {
  data: function () {
    return {
      expriedDate: null,
      expriedTime: null,
      isEdit: false,
      botStatus: false,
      isEditAccessToken: false,
      isEditChannelSecret: false,
      isEditChannelId: false,
      line: {
        line_access_token: null,
        line_channel_secret: null,
        line_channel_id: null,
      },
      showCopy: false,
    }
  },
  watch: {
    selectedBotStatus() {
      let vm = this
      vm.botStatus = vm.selectedBot.status
    },
  },
  mounted: async function () {
    var vm = this
    await vm.getLineToken()

    vm.cached_line = JSON.stringify(vm.line)
    // if (!vm.line.line_access_token || !vm.line.line_channel_secret) {
    //   vm.isEditAccessToken = true
    //   vm.isEditChannelId = true
    //   vm.isEditChannelSecret = true
    // }
  },
  components: {
    Typography,
  },
  computed: {
    selectedBotStatus() {
      return this.selectedBot.status
    },
    selectedBot: {
      get() {
        if (this.$store.state.selectedBot == null) {
          return null
        }
        var now = moment()
        var expriedDate = moment(this.$store.state.selectedBot.expireat)
        this.expriedDate = parseInt(expriedDate.diff(now, 'days'))
        this.expriedTime = parseInt(expriedDate.diff(now, 'seconds'))
        return this.$store.state.selectedBot
      },
      set(bot) {
        let vm = this
        vm.currentBot = bot
        vm.$store.dispatch('selectBot', vm.currentBot)
        location.reload()
      },
    },
    webhookUrl: function () {
      return config.serverUrl + 'webhookline?facebookpageid=' + this.selectedBot.pageid
    },
  },
  methods: {
    saveEditLine: function (type) {
      var vm = this
      if (vm.$store.getters.getPackage !== 'premium') {
        vm.line = JSON.parse(vm.cached_line)
        if (type === 'AccessToken') {
          vm.isEditAccessToken = false
          return
        } else if (type === 'ChannelSecret') {
          vm.isEditChannelSecret = false
          return
        } else if (type === 'ChannelId') {
          vm.isEditChannelId = false
          return
        }
      }
      vm.$store.dispatch('loading')
      api.saveLineToken(
        {
          pageid: vm.selectedBot.pageid,
          line_access_token: vm.line.line_access_token ? vm.line.line_access_token.trim() : '',
          line_channel_secret: vm.line.line_channel_secret
            ? vm.line.line_channel_secret.trim()
            : '',
          line_channel_id: vm.line.line_channel_id ? vm.line.line_channel_id.trim() : '',
        },
        function (error, response) {
          if (error) {
            vm.$store.dispatch('loading')
          }
          vm.cached_line = JSON.stringify(vm.line)
          if (type === 'AccessToken') {
            vm.isEditAccessToken = false
          } else if (type === 'ChannelSecret') {
            vm.isEditChannelSecret = false
          } else if (type === 'ChannelId') {
            vm.isEditChannelId = false
          }
          vm.$store.dispatch('loading')
          location.reload()
        }
      )
    },
    getLineToken: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getLineToken({ pageid: vm.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
            vm.$store.dispatch('loading')
          }
          vm.line = {
            line_access_token: response.data.line_access_token,
            line_channel_secret: response.data.line_channel_secret,
            line_channel_id: response.data.line_channel_id,
          }
          resolve()
        })
      })
    },
    onCopy: function () {
      let vm = this
      vm.showCopy = true
      setTimeout(() => {
        vm.showCopy = false
      }, 1000)
    },
    onError: function () {},
  },
}
</script>



// WEBPACK FOOTER //
// src/components/view/billing/LineChatbot.vue